import { IconWrapper } from '../runtime';
export default IconWrapper('pdf_format', false, function (h, props) {
  return h("svg", {
    "attrs": {
      "width": props.size,
      "height": props.size,
      "viewBox": "0 0 24 24",
      "fill": "none"
    }
  }, [h("path", {
    "attrs": {
      "d": "M0 3C0 1.34315 1.34315 0 3 0H21C22.6569 0 24 1.34315 24 3V21C24 22.6569 22.6569 24 21 24H3C1.34315 24 0 22.6569 0 21V3Z",
      "fill": "#EB2F3B"
    }
  }), h("path", {
    "attrs": {
      "d": "M0 18.375H24V21C24 22.6569 22.6569 24 21 24H3C1.34315 24 0 22.6569 0 21V18.375Z",
      "fill": "#CE1E29"
    }
  }), h("path", {
    "attrs": {
      "d": "M21 1.14742e-07C22.6569 1.87166e-07 24 1.34315 24 3L24 21.0968C24 22.7002 22.7002 24 21.0968 24C19.5936 24 18.375 22.7814 18.375 21.2782L18.375 0L21 1.14742e-07Z",
      "fill": "#FF4F5A"
    }
  }), h("path", {
    "attrs": {
      "d": "M18.375 21.2782C18.375 22.7814 19.5936 24 21.0968 24C22.7002 24 24 22.7002 24 21.0968C24 19.5936 22.7814 18.375 21.2782 18.375H18.375V21.2782Z",
      "fill": "#EB2F3B"
    }
  }), h("g", {
    "attrs": {
      "clip-path": "url(#clip0_913_637)"
    }
  }, [h("path", {
    "attrs": {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      "d": "M7.875 3.375H11.7188C13.6345 3.375 15.1875 4.92801 15.1875 6.84375C15.1875 8.75949 13.6345 10.3125 11.7188 10.3125H9.75V15H6.46875C4.65657 15 3.1875 13.5309 3.1875 11.7188C3.1875 9.90657 4.65657 8.4375 6.46875 8.4375H7.875V3.375ZM7.875 10.3125H6.46875C5.6921 10.3125 5.0625 10.9421 5.0625 11.7188C5.0625 12.4954 5.6921 13.125 6.46875 13.125H7.875V10.3125ZM9.75 8.4375H11.7188C12.599 8.4375 13.3125 7.72395 13.3125 6.84375C13.3125 5.96355 12.599 5.25 11.7188 5.25H9.75V8.4375Z",
      "fill": "white"
    }
  })]), h("defs", [h("clipPath", {
    "attrs": {
      "id": "clip0_913_637"
    }
  }, [h("rect", {
    "attrs": {
      "width": "12.375",
      "height": "12.375",
      "fill": "white",
      "transform": "translate(3 3)"
    }
  })])])]);
});